<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
:root {
  --rw-bg: #e5f5fb;
  --rw-panel: #f9fdff;
  --rw-white: #ffffff;
  --rw-primary: #10b5c8;
  --rw-primary-2: #22c1c3;
  --rw-primary-3: #8dd8f6;
  --rw-text: #0f172a;
  --rw-muted: #6b7280;
  --rw-border: rgba(148, 163, 184, 0.22);
  --rw-shadow: 0 18px 45px rgba(15, 23, 42, 0.1);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--rw-bg);
  color: var(--rw-text);
}

#app {
  height: 100%;
  overflow: hidden;
}
</style>
